import {Component, inject, OnInit} from '@angular/core';
import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";

@Component({
  selector: 'app-active-ride',
  imports: [
    FooterComponent,
    HeaderComponent,
    ReactiveFormsModule
  ],
  templateUrl: './active-ride.component.html',
  styleUrl: './active-ride.component.css'
})
export class ActiveRideComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: boolean }[] = [];
  radioControl = new FormControl();

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.yes,
        caption: '',
        value: true
      },
      {
        headline: this.locale.currentTranslation.no,
        caption: '',
        value: false
      }
    ]
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.isActiveRider !== null) {
        this.radioControl = new FormControl(this.claimService.claimReport().isActiveRider);
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError) {
      this.claimService.updateClaimReport({isActiveRider: this.radioControl.getRawValue()});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['active-ride']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: boolean) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
